import { Component } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mensaje-propietario',
  standalone: false,
  templateUrl: './mensaje-propietario.component.html',
  styleUrl: './mensaje-propietario.component.scss'
})

export class MensajePropietarioComponent {
  
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _dataLayerService: DataLayerService
  ) { }
  
  sessionId: string = '';
  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER;
  json: string = '';
  jsonFinal: string = '';
  parametro: string = '';
  leadId: string = '';
  addSpacing: boolean = false;

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  ngOnInit(): void {
    this.localTimer = environment.LOCAL_TIMER;
    this.sessionId = this.getLocalStorage().toString();

    // Obtener información de la URL completa
    const url = window.location;
    const ruta = url.pathname; 

    if(ruta.includes('cotizadores')){
      this.addSpacing = true; 
    }
    
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);

        this._dataLayerService.logDatos('ecommerce_step_8', 'Arrendamiento', 'Finalizacion',
          this.sessionId, this.datosGenerales.InfoArrendamiento.valorArriendo.toString(),
          this.datosGenerales.InfoArrendamiento.valorAdministracion.toString(),
          this.datosGenerales.InfoArrendamiento.tipoPropiedad,
          this.datosGenerales.InfoArrendamiento.ubicacion, this.datosGenerales.InfoArrendamiento.ubicacion,
          this.datosGenerales.InfoArrendamiento.duracionContrato,
          this.datosGenerales.InfoArrendamiento.fechaContrato, this.datosGenerales.PlanSeleccionado.plan,
          this.datosGenerales.PlanSeleccionado.valorPlan.toString(), this.datosGenerales.InfoArrendamiento.ServiciosPublicos ? 'true' : 'false',
          this.datosGenerales.InfoArrendamiento.PaquetesAsistencia ? 'true' : 'false',
          this.datosGenerales.Inmueble.ciudad, this.datosGenerales.Inmueble.maticula);
      }
    });
  }


  entendido() {
    // se debe crear lead
    window.location.href = "https://www.sura.co/";
    //this.router.navigate(['ResumenProceso', { idLead: this.leadId, infoCliente: btoa(this.parametro) }]);
  }

}
